import React, { useEffect, useState } from "react";
import query from "jquery";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { handleError } from "../utils/functions";
import axiosInstance from "../config/axios.config";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { currencies, languages } from "../constant/data";
import useCurrency from "../hooks/useCurrency";
import { useTranslation } from "react-i18next";
import useLanguage from "../hooks/useLanguage";
import { clearAuth } from "../store/slice/auth";
import { updateCountry } from "../store/slice/config";

const CategoryItem = ({ category, subcategories }) => {
  return (
    <li className="has-submenus-submenu">
      <Link to="#" className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0">
        <span>{category?.name}</span>
        <span className="icon text-md d-flex ms-auto">
          <i className="ph ph-caret-right" />
        </span>
      </Link>
      <div className="submenus-submenu py-16">
        <h6 className="text-lg px-16 submenus-submenu__title">{category.name}</h6>
        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
          {subcategories.map((item) => (
            <li key={item._id}>
              <Link to={`/products?category=${category._id}&subcategory=${item._id}`}>{item.name}</Link>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};

const SidbarCategoryItem = ({
  handleCatClick,
  setActiveIndexCat,
  activeIndexCat,
  category,
  subcategories,
  index,
}) => {
  return (
    <li
      onClick={() => handleCatClick(0)}
      className={`has-submenus-submenu ${activeIndexCat === 0 ? "active" : ""}`}
    >
      <Link
        onClick={() => setActiveIndexCat(null)}
        to="#"
        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
      >
        <span>{category.name}</span>
        <span className="icon text-md d-flex ms-auto">
          <i className="ph ph-caret-right" />
        </span>
      </Link>
      <div className={`submenus-submenu py-16 ${activeIndexCat === index ? "open" : ""}`}>
        <h6 className="text-lg px-16 submenus-submenu__title">{category.name}</h6>
        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
          {subcategories.map((item) => (
            <li key={item._id}>
              <Link to={`/products?category=${category._id}&subcategory=${item._id}`}>{item.name}</Link>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};

const HeaderTwo = ({ category, subcategories, categories }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [currency, setCurrency] = useCurrency();
  const [langauge, setLanguage] = useLanguage();
  const { token, user } = useSelector((state) => state.auth);
  const { totalQuantity } = useSelector((state) => state.cart);
  const { countryCode } = useSelector((state) => state.config);
  const [scroll, setScroll] = useState(false);
  const [myCategory, setMyCategory] = useState(category ? [] : categories);
  const [mySubcategory, setMySubcategory] = useState(category ? [] : subcategories);
  const [country, setCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  useEffect(() => {
    const getData = async () => {
      try {
        const { data } = await axiosInstance.get("/home/category");
        if (!data.error) {
          setMyCategory(data.data.categories);
          setMySubcategory(data.data.subcategories);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        handleError(error);
      }
    };
    getData();
  }, [category]);

  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // Search control support
  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => {
    setActiveSearch(!activeSearch);
  };

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);
  const handleCategoryToggle = () => {
    setActiveCategory(!activeCategory);
  };
  const [activeIndexCat, setActiveIndexCat] = useState(null);
  const handleCatClick = (index) => {
    setActiveIndexCat(activeIndexCat === index ? null : index);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const search = fd.get("search");
    const categoryId = fd.get("categoryId");

    if (!search && !categoryId) {
      return;
    }

    navigate(`/search?search=${search}&categoryId=${categoryId}`);
  };

  useEffect(() => {
    const getCountry = async () => {
      try {
        const { data } = await axiosInstance.get("/country/active");
        if (!data.error) {
          setCountry(data.data);
          setSelectedCountry(data.countryCode);
        }
      } catch (error) {
        handleError(error);
      }
    };
    getCountry();
  }, []);

  const handleLogout = () => {
    dispatch(clearAuth());
    window.location.assign("/");
  };

  return (
    <>
      <div className="overlay" />
      <div className={`side-overlay ${(menuActive || activeCategory) && "show"}`} />
      {/* ==================== Mobile Menu Start Here ==================== */}
      <div className={`mobile-menu scroll-sm d-lg-none d-block ${menuActive && "active"}`}>
        <button
          onClick={() => {
            handleMenuToggle();
            setActiveIndex(null);
          }}
          type="button"
          className="close-button"
        >
          <i className="ph ph-x" />{" "}
        </button>
        <div className="mobile-menu__inner">
          <Link to="/" className="mobile-menu__logo">
            <img src="/assets/images/logo/colour.png" alt="Logo" />
          </Link>
          <div className="mobile-menu__menu">
            {/* Nav Menu Start */}
            <ul className="nav-menu flex-align nav-menu--mobile">
              <li className="nav-menu__item">
                <NavLink
                  to="/"
                  className={(navData) => (navData.isActive ? "nav-menu__link activePage" : "nav-menu__link")}
                >
                  {t("home")}
                </NavLink>
              </li>
              <li className="nav-menu__item">
                <NavLink
                  to="/shops"
                  className={(navData) => (navData.isActive ? "nav-menu__link activePage" : "nav-menu__link")}
                >
                  {t("shops")}
                </NavLink>
              </li>
              <li className="nav-menu__item">
                <NavLink
                  to="/products"
                  className={(navData) => (navData.isActive ? "nav-menu__link activePage" : "nav-menu__link")}
                >
                  {t("products")}
                </NavLink>
              </li>
              <li className="nav-menu__item">
                <NavLink
                  to="/seller-register"
                  className={(navData) => (navData.isActive ? "nav-menu__link activePage" : "nav-menu__link")}
                >
                  {t("becomeAShop")}
                </NavLink>
              </li>
              <li className="nav-menu__item">
                <NavLink
                  to="/contact"
                  className={(navData) => (navData.isActive ? "nav-menu__link activePage" : "nav-menu__link")}
                >
                  {t("contactUs")}
                </NavLink>
              </li>
              <li className="nav-menu__item">
                <li className="on-hover-item mt-30 border-right-item border-right-item-sm-space has-submenu arrow-white">
                  <div className="location-box bg-white flex-align gap-8 py-6 px-16 rounded-pill border border-gray-100">
                    <span className="text-gray-900 text-xl d-xs-flex d-none">
                      <i className="ph ph-map-pin" />
                    </span>
                    <div className="line-height-1">
                      <span className="text-gray-600 text-xs">{t("yourLocation")}</span>
                      <div className="line-height-1 border-0">
                        <select
                          className="border-0"
                          value={countryCode}
                          onChange={(e) => {
                            dispatch(updateCountry(e.target.value));
                            window.location.reload();
                          }}
                        >
                          {country.map((item) => (
                            <option value={item.value} key={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </li>
              </li>
            </ul>
            {/* Nav Menu End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}
      {/* ======================= Middle Header Two Start ========================= */}
      <header className="header-middle style-two bg-color-neutral">
        <div className="container container-lg">
          <nav className="header-inner flex-between">
            {/* Logo Start */}
            <div className="logo">
              <Link to="/" className="link">
                <img src="/assets/images/logo/logo-two.png" alt="Logo" />
              </Link>
            </div>
            {/* Logo End  */}
            {/* form Category Start */}
            <div className="flex-align">
              <div className="select-dropdown-for-home-two">
                {/* Dropdown Select Start */}
                {/* <ul className="header-top__right style-two flex-align flex-wrap d-block d-md-none">
                  <li className="customSelecter on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                    <div className="selected-text text-white text-sm">{langauge}</div>
                    <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                      {languages.map((item) => (
                        <li>
                          <Link
                            to="#"
                            className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                            onClick={() => setLanguage(item.value)}
                          >
                            <img
                              src="assets/images/thumbs/flag1.png"
                              alt={item.label}
                              className="w-16 h-12 rounded-4 border border-gray-100"
                            />
                            {item.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul> */}
                <div className="d-block d-md-none">
                  <ul className="header-top__right style-two flex-align flex-wrap ">
                    <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                      <Link
                        to="#"
                        className="selected-text text-heading text-sm py-8"
                        style={{ textTransform: "capitalize" }}
                      >
                        {langauge}
                      </Link>
                      <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                        {languages.map((item) => (
                          <li>
                            <Link
                              to="#"
                              className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                              onClick={() => setLanguage(item.value)}
                            >
                              <img
                                src="assets/images/thumbs/flag1.png"
                                alt={item.label}
                                className="w-16 h-12 rounded-4 border border-gray-100"
                              />
                              {item.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                    <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                      <a
                        href="javascript:void(0)"
                        className="selected-text text-heading text-sm py-8"
                        style={{ textTransform: "capitalize" }}
                      >
                        {currency}
                      </a>
                      <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                        {currencies.map((item) => (
                          <li style={{ cursor: "pointer" }} onClick={() => setCurrency(item.value)}>
                            <a
                              href="javascript:void(0)"
                              className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                            >
                              <img
                                src="assets/images/thumbs/flag1.png"
                                alt=""
                                className="w-16 h-12 rounded-4 border border-gray-100"
                              />
                              {item.value}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </div>

                {/* Dropdown Select End */}
              </div>
              <form className="flex-align flex-wrap form-location-wrapper" onSubmit={handleSearch}>
                <div className="search-category style-two d-flex h-48 search-form d-sm-flex d-none">
                  <select
                    defaultValue={1}
                    className="js-example-basic-single border border-gray-200 border-end-0 rounded-0 border-0"
                    name="categoryId"
                  >
                    {/* <option value="">{t("allCategories")}</option> */}
                    {myCategory.map((item) => (
                      <option value={item._id}>{item.name}</option>
                    ))}
                  </select>
                  <div className="search-form__wrapper position-relative">
                    <input
                      type="text"
                      className="search-form__input common-input py-13 ps-16 pe-18 rounded-0 border-0"
                      placeholder={t("searchPlaceholder")}
                      name="search"
                    />
                  </div>
                  <button
                    type="submit"
                    className="bg-main-two-600 flex-center text-md px-10 text-white flex-shrink-0 hover-bg-main-two-700 d-lg-flex d-none"
                  >
                    {t("search")} &nbsp; <i className="ph ph-magnifying-glass" />
                  </button>
                </div>
              </form>
            </div>
            {/* form Category start */}
            {/* Header Middle Right start */}
            <div className="header-right flex-align d-lg-block d-none">
              <div className="header-two-activities flex-align flex-wrap gap-32">
                <button
                  type="button"
                  className="flex-align search-icon d-lg-none d-flex gap-4 item-hover-two"
                >
                  <span className="text-2xl text-white d-flex position-relative item-hover__text">
                    <i className="ph ph-magnifying-glass" />
                  </span>
                </button>

                {token ? (
                  <div className="on-hover-item border-right-item customRemove border-right-item-sm-space has-submenu arrow-white">
                    <div
                      to="/dashboard/home"
                      className="flex-align cursor-pointer flex-column gap-2 item-hover-two"
                    >
                      <span className="text-2xl text-white d-flex position-relative item-hover__text">
                        <i className="ph ph-user" />
                      </span>
                      <span className="text-sm text-white item-hover__text d-none d-lg-flex">
                        {t("profile")}
                      </span>
                    </div>
                    <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                      <li>
                        <Link
                          to="/dashboard/profile"
                          className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                        >
                          {t("profile")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/dashboard/chat"
                          className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                        >
                          {t("chat")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/dashboard/wishlist"
                          className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                        >
                          {t("wishlist")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/dashboard/order"
                          className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                        >
                          {t("myOrders")}
                        </Link>
                      </li>
                      {user?.platform === "email" && (
                        <li>
                          <Link
                            to="/dashboard/password"
                            className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                          >
                            {t("changePassword")}
                          </Link>
                        </li>
                      )}
                      <li>
                        <Link
                          to="#"
                          className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                          onClick={handleLogout}
                        >
                          {t("logout")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <Link to="/user-login" className="flex-align flex-column gap-2 item-hover-two">
                    <span className="text-2xl text-white d-flex position-relative item-hover__text">
                      <i className="ph ph-user" />
                    </span>
                    <span className="text-sm text-white item-hover__text d-none d-lg-flex">{t("login")}</span>
                  </Link>
                )}

                <Link to="/cart" className="flex-align flex-column gap-2 item-hover-two">
                  <span className="text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-shopping-cart-simple" />
                    <span className="w-16 h-16 flex-center rounded-circle bg-main-two-600 text-white text-xs position-absolute top-n6 end-n4">
                      {totalQuantity}
                    </span>
                  </span>
                  <span className="text-sm text-white item-hover__text d-none d-lg-flex">{t("cart")}</span>
                </Link>
              </div>
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>
      </header>
      {/* ======================= Middle Header Two End ========================= */}
      {/* ==================== Header Two Start Here ==================== */}
      <header className={`header bg-white border-bottom border-gray-100 ${scroll && "fixed-header"}`}>
        <div className="container container-lg">
          <nav className="header-inner d-flex justify-content-between gap-8">
            <div className="flex-align menu-category-wrapper">
              {/* Category Dropdown Start */}
              <div className={`category-two ${category === false ? "d-block" : "d-none"} `}>
                <button
                  onClick={handleCategoryToggle}
                  type="button"
                  className="category__button flex-align gap-8 fw-medium bg-main-two-600 p-16 text-white"
                >
                  <span className="icon text-2xl d-xs-flex d-none">
                    <i className="ph ph-dots-nine" />
                  </span>
                  <span className="d-sm-flex d-none">{t("allCategories")}</span>
                  <span className="arrow-icon text-xl d-flex">
                    <i className="ph ph-caret-down" />
                  </span>
                </button>
                <div
                  className={`responsive-dropdown cat common-dropdown d-lg-none d-block nav-submenu p-0 submenus-submenu-wrapper shadow-none border border-gray-100 ${
                    activeCategory && "active"
                  }`}
                >
                  <button
                    onClick={() => {
                      handleCategoryToggle();
                      setActiveIndexCat(null);
                    }}
                    type="button"
                    className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                  >
                    <i className="ph ph-x" />{" "}
                  </button>
                  <div className="logo px-16 d-lg-none d-block">
                    <Link to="/" className="link">
                      <img src="/assets/images/logo/colour.png" alt="Logo" />
                    </Link>
                  </div>
                  <ul className="scroll-sm p-0 py-8 overflow-y-auto">
                    {myCategory.map((category, index) => (
                      <SidbarCategoryItem
                        key={category._id}
                        category={category}
                        activeIndexCat={activeIndexCat}
                        handleCatClick={handleCatClick}
                        setActiveIndexCat={setActiveIndexCat}
                        subcategories={mySubcategory.filter((item) => item.categoryId === category._id)}
                        index={index}
                      />
                    ))}
                  </ul>
                </div>
              </div>
              <div
                className={`category main  on-hover-item bg-main-600 text-white ${
                  category === true ? "d-block" : "d-none"
                }`}
              >
                <button
                  type="button"
                  className="category__button flex-align gap-8 fw-medium p-16 border-end border-start border-gray-100 text-white"
                >
                  <span className="icon text-2xl d-xs-flex d-none">
                    <i className="ph ph-dots-nine" />
                  </span>
                  <span className="d-sm-flex d-none">{t("allCategories")}</span>
                  <span className="arrow-icon text-xl d-flex">
                    <i className="ph ph-caret-down" />
                  </span>
                </button>
                <div className="responsive-dropdown on-hover-dropdown common-dropdown nav-submenu p-0 submenus-submenu-wrapper">
                  <button
                    type="button"
                    className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                  >
                    <i className="ph ph-x" />{" "}
                  </button>
                  <div className="logo px-16 d-lg-none d-block">
                    <Link to="/" className="link">
                      <img src="assets/images/logo/logo.png" alt="Logo" />
                    </Link>
                  </div>

                  {/* Category Menu to Work */}
                  <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto">
                    {myCategory?.map((category) => (
                      <CategoryItem
                        key={category._id}
                        category={category}
                        subcategories={mySubcategory.filter((item) => item.categoryId === category._id)}
                      />
                    ))}
                  </ul>
                </div>
              </div>
              {/* Category Dropdown End  */}
              {/* Menu Start  */}
              <div className="header-menu d-lg-block d-none">
                {/* Nav Menu Start */}
                <ul className="nav-menu flex-align ">
                  <li className="nav-menu__item">
                    <NavLink
                      to="/"
                      className={(navData) =>
                        navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"
                      }
                    >
                      {t("home")}
                    </NavLink>
                  </li>
                  <li className="nav-menu__item">
                    <NavLink
                      to="/shops"
                      className={(navData) =>
                        navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"
                      }
                    >
                      {t("shops")}
                    </NavLink>
                  </li>
                  <li className="nav-menu__item">
                    <NavLink
                      to="/products"
                      className={(navData) =>
                        navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"
                      }
                    >
                      {t("products")}
                    </NavLink>
                  </li>
                  <li className="nav-menu__item">
                    <NavLink
                      to="/seller-register"
                      className={(navData) =>
                        navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"
                      }
                    >
                      {t("becomeAShop")}
                    </NavLink>
                  </li>
                  <li className="nav-menu__item">
                    <NavLink
                      to="/contact"
                      className={(navData) =>
                        navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"
                      }
                    >
                      {t("contactUs")}
                    </NavLink>
                  </li>
                </ul>
                {/* Nav Menu End */}
              </div>
              {/* Menu End  */}
            </div>
            {/* Header Right start */}
            <div className="header-right flex-align">
              <div className="select-dropdown-for-home-two d-lg-block d-none">
                {/* Dropdown Select Start */}
                <ul className="header-top__right style-two flex-align flex-wrap">
                  <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                    <div className="location-box bg-white flex-align gap-8 py-6 px-16 rounded-pill border border-gray-100">
                      <span className="text-gray-900 text-xl d-xs-flex d-none">
                        <i className="ph ph-map-pin" />
                      </span>
                      <div className="line-height-1 ">
                        <span className="text-gray-600 text-xs">{t("yourLocation")}</span>
                        <div className="line-height-1 border-0">
                          <select
                            className="border-0"
                            value={countryCode}
                            onChange={(e) => {
                              dispatch(updateCountry(e.target.value));
                              window.location.reload();
                            }}
                          >
                            {country.map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                    <Link
                      to="#"
                      className="selected-text text-heading text-sm py-8"
                      style={{ textTransform: "capitalize" }}
                    >
                      {langauge}
                    </Link>
                    <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                      {languages.map((item) => (
                        <li>
                          <Link
                            to="#"
                            className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                            onClick={() => setLanguage(item.value)}
                          >
                            <img
                              src="assets/images/thumbs/flag1.png"
                              alt={item.label}
                              className="w-16 h-12 rounded-4 border border-gray-100"
                            />
                            {item.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                    <a
                      href="javascript:void(0)"
                      className="selected-text text-heading text-sm py-8"
                      style={{ textTransform: "capitalize" }}
                    >
                      {currency}
                    </a>
                    <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                      {currencies.map((item) => (
                        <li style={{ cursor: "pointer" }} onClick={() => setCurrency(item.value)}>
                          <a
                            href="javascript:void(0)"
                            className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                          >
                            <img
                              src="assets/images/thumbs/flag1.png"
                              alt=""
                              className="w-16 h-12 rounded-4 border border-gray-100"
                            />
                            {item.value}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
                {/* Dropdown Select End */}
              </div>
              <div className="d-lg-none d-block">
                <div className="header-two-activities flex-align flex-wrap gap-32">
                  {token ? (
                    <div className="on-hover-item customRemove has-submenu arrow-white">
                      <div
                        to="/dashboard/home"
                        className="flex-align cursor-pointer flex-column gap-2 item-hover-two"
                      >
                        <span className="text-2xl text-white d-flex position-relative item-hover__text">
                          <i className="ph ph-user" />
                        </span>
                        <span className="text-sm text-white item-hover__text d-none d-lg-flex">
                          {t("profile")}
                        </span>
                      </div>
                      <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                        <li>
                          <Link
                            to="/dashboard/profile"
                            className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                          >
                            {t("profile")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/dashboard/chat"
                            className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                          >
                            {t("chat")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/dashboard/wishlist"
                            className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                          >
                            {t("wishlist")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/dashboard/order"
                            className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                          >
                            {t("myOrders")}
                          </Link>
                        </li>
                        {user?.platform === "email" && (
                          <li>
                            <Link
                              to="/dashboard/password"
                              className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                            >
                              {t("changePassword")}
                            </Link>
                          </li>
                        )}
                        <li>
                          <Link
                            to="#"
                            className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                            onClick={handleLogout}
                          >
                            {t("logout")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <Link to="/user-login" className="flex-align flex-column gap-2 item-hover-two">
                      <span className="text-2xl text-white d-flex position-relative item-hover__text">
                        <i className="ph ph-user" />
                      </span>
                      <span className="text-sm text-white item-hover__text d-none d-lg-flex">
                        {t("login")}
                      </span>
                    </Link>
                  )}
                  <Link to="/cart" className="flex-align flex-column gap-8 item-hover-two">
                    <span className="text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-shopping-cart-simple" />
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-two-600 text-white text-xs position-absolute top-n6 end-n4">
                        {totalQuantity}
                      </span>
                    </span>
                    <span className="text-md text-white item-hover__text d-none d-lg-flex">Cart</span>
                  </Link>
                </div>
              </div>
              <button
                onClick={handleMenuToggle}
                type="button"
                className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-2xl d-flex"
              >
                {" "}
                <i className="ph ph-list" />{" "}
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}
    </>
  );
};

export default HeaderTwo;
